<template>
  <b-navbar spaced fixed-top shadow>
    <template slot="brand">
      <b-navbar-item>
        <img src="../assets/zieslogowebsite.png" alt="Zies" />
      </b-navbar-item>
      <b-navbar-item>Zies Tekno Indonesia</b-navbar-item>
    </template>
    <template slot="end">
      <b-navbar-item href="#solutions">Solutions</b-navbar-item>
      <b-navbar-item href="#partners">Partners</b-navbar-item>
      <b-navbar-item href="#contacts">Contact Us</b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  name: "Navbar",
  components: {},
  data: function () {
    return {
      isMenuActive: false,
    };
  },
  created() {},
  methods: {},
};
</script>

<style scoped></style>
